module.exports = __webpack_public_path__ + "img/Jump Casting25.5733d12e.jpg";